module.exports = __webpack_public_path__ + "static/media/footer-mobile.e73ca1d4.png";